import { CouponRedemptionListUrlSortField } from "@saleor/coupons/url";
import { CouponRedemptionSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: CouponRedemptionListUrlSortField
): CouponRedemptionSortField {
  switch (sort) {
    case CouponRedemptionListUrlSortField.code:
      return CouponRedemptionSortField.CODE;
    case CouponRedemptionListUrlSortField.claimedAt:
      return CouponRedemptionSortField.CLAIMED_AT;
    case CouponRedemptionListUrlSortField.redeemedAt:
      return CouponRedemptionSortField.REDEEMED_AT;
    default:
      return undefined;
  }
}

export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
